enum TalkTypes {
  TedStageTalk = '1',
  TedXTalk = '2',
  TedEdOriginal = '3',
  TedInstituteTalk = '4',
  BestOfWeb = '5',
  TedSalonTalk = '7',
  CustomSponsoredContent = '8'
}

export default TalkTypes;
